import { render, staticRenderFns } from "./SingleOutrightOutcome.vue?vue&type=template&id=30af7756"
import script from "./SingleOutrightOutcome.vue?vue&type=script&lang=js"
export * from "./SingleOutrightOutcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports